import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import logo from '../assets/logo1.png';
import PersonIcon from '@mui/icons-material/Person';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setCurrentUser } from '../context/sessionSlice';
import MenuIcon from '@mui/icons-material/Menu';
import DownloadReports from "./pages/downloadReports/downloadReports";
import {SnackbarProvider} from "notistack";
import DownloadRequestToast from "./toasts/DownloadRequestToast/downloadRequestToast";

const pages = ['Dashboard'];  // ,'CDR'
const settings = ['Logout'];

function ResponsiveAppBar() {
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [anchorElCDR, setAnchorElCDR] = React.useState(null);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };


    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleNavigation = (page) => {
        handleCloseNavMenu();
        navigate(`/${page.toLowerCase()}`)
    };

    ////

    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleUserMenuItemClick = (setting) => {
        handleCloseUserMenu();

        if(setting === 'Logout') {
            navigate('/logout');
        }

    }

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    ///

    const handleOpenCDRMenu = (event) => {
        setAnchorElCDR(event.target);
    }

    const handleCloseCDRMenu = () => {
        setAnchorElCDR(null);
    }

    const handleCDRMenuItemClick = (path) => {
        handleCloseCDRMenu();
        navigate(path);
    }

    return (
        <AppBar position="static" color="transparent">
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon/>
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: { xs: 'block', md: 'none' },
                            }}
                        >
                            <MenuItem onClick={() => handleNavigation('/dashboard')}>
                                   <Typography textAlign="center">Dashboard</Typography>
                            </MenuItem>
                            <MenuItem onClick={() => handleNavigation('/cdr/current')}>
                                   <Typography textAlign="center">Current</Typography>
                            </MenuItem>
                            <MenuItem onClick={() => handleNavigation('/cdr/historical')}>
                                <Typography textAlign="center">Historical</Typography>
                            </MenuItem>
                            <MenuItem onClick={() => handleNavigation('/cdr/hourly')}>
                                <Typography textAlign="center">Hourly</Typography>
                            </MenuItem>
                            <MenuItem onClick={() => handleNavigation('/downloadReports')}>
                                <Typography textAlign="center">Download Reports</Typography>
                            </MenuItem>
                        </Menu>
                    </Box>

                    <img src={logo} style={{ width: '100px' }} alt="logo" />

                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                        <Button
                            key={'dashboard'}
                            onClick={() => handleNavigation('dashboard')}
                            sx={{ my: 2, color: 'black', display: 'block' }}
                        >
                            dashboard
                        </Button>

                       <Box>
                           <Button
                               key={'cdr'}
                               onClick={handleOpenCDRMenu}
                               sx={{ my: 2, color: 'black', display: 'block' }}
                           >
                               cdr
                           </Button>
                           <Menu
                               sx={{ mt: '45px' }}
                               anchorEl={anchorElCDR}
                               anchorOrigin={{
                                   vertical: 'top',
                                   horizontal: 'right',
                               }}
                               keepMounted
                               transformOrigin={{
                                   vertical: 'top',
                                   horizontal: 'right',
                               }}
                               open={Boolean(anchorElCDR)}
                               onClose={handleCloseCDRMenu}
                           >
                               <MenuItem onClick={() => handleCDRMenuItemClick('/cdr/current')}>
                                   <Typography textAlign="center">Current</Typography>
                               </MenuItem>
                               <MenuItem onClick={() => handleCDRMenuItemClick('/cdr/historical')}>
                                   <Typography textAlign="center">Historical</Typography>
                               </MenuItem>
                                <MenuItem onClick={() => handleCDRMenuItemClick('/cdr/hourly')}>
                                    <Typography textAlign="center">Hourly</Typography>
                                </MenuItem>
                           </Menu>
                       </Box>

                        {/* <Button
                            key={'downloadReports'}
                            onClick={() => handleNavigation('downloadReports')}
                            sx={{ my: 2, color: 'black', display: 'block' }}
                        >
                            Download Reports
                        </Button> */}
                    </Box>

                    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                    </Box>

                    <Box sx={{ flexGrow: 0 }}>
                        <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                            <PersonIcon />
                        </IconButton>
                        <Menu
                            sx={{ mt: '45px' }}
                            id="menu-appbar"
                            anchorEl={anchorElUser}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorElUser)}
                            onClose={handleCloseUserMenu}
                        >
                            {settings.map((setting) => (
                                <MenuItem key={setting} onClick={() => handleUserMenuItemClick(setting)}>
                                    <Typography textAlign="center">{setting}</Typography>
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
}


function Frame({children}) {

    return (<>
        <ResponsiveAppBar />
        <SnackbarProvider Components={{
            downloadRequest: DownloadRequestToast
        }}>
            <div style={{padding: '30px'}}>
                {children}
            </div>
        </SnackbarProvider>
    </>)
}

export default Frame;
